import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const Wheel = ({ cx, rotate }) => (
  <motion.g style={{ rotate, transformBox: "fill-box", transformOrigin: "50% 50%" }}>
    <circle cx={cx} cy="76" r="12" fill="#111827" />
    <circle cx={cx} cy="76" r="5" fill="#9CA3AF" />
    <line x1={cx - 12} y1="76" x2={cx + 12} y2="76" stroke="#4B5563" strokeWidth="2" />
  </motion.g>
);

export const ScrollTruck = ({ targetRef }) => {
  const { scrollYProgress } = useScroll({ target: targetRef, offset: ["start end", "end end"] });
  const smooth = useSpring(scrollYProgress, { stiffness: 55, damping: 20 });
  const x = useTransform(smooth, [0, 1], ["-20vw", "105vw"]);
  const rotate = useTransform(smooth, [0, 1], [0, 4200]);

  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-truck"
      className="pointer-events-none fixed bottom-3 left-0 z-40 w-24 md:bottom-6 md:w-36"
      style={{ x }}
    >
      <div className="animate-truck-bob">
        <svg viewBox="0 0 240 100" className="w-full drop-shadow-xl">
          <ellipse cx="120" cy="92" rx="105" ry="6" fill="#0A192F" opacity="0.12" />
          <rect x="18" y="54" width="128" height="10" rx="2" fill="#1F2937" />
          <rect x="24" y="20" width="116" height="34" rx="3" fill="#E5E7EB" stroke="#1A365D" strokeOpacity="0.25" />
          <rect x="24" y="44" width="116" height="5" fill="#EAB308" />
          <line x1="48" y1="20" x2="48" y2="54" stroke="#1A365D" strokeOpacity="0.15" strokeWidth="2" />
          <line x1="72" y1="20" x2="72" y2="54" stroke="#1A365D" strokeOpacity="0.15" strokeWidth="2" />
          <line x1="96" y1="20" x2="96" y2="54" stroke="#1A365D" strokeOpacity="0.15" strokeWidth="2" />
          <line x1="120" y1="20" x2="120" y2="54" stroke="#1A365D" strokeOpacity="0.15" strokeWidth="2" />
          <path d="M146 64 v-34 a6 6 0 0 1 6 -6 h30 a8 8 0 0 1 7 4 l14 22 a8 8 0 0 1 1 4 v10 z" fill="#0A192F" />
          <path d="M156 30 h24 a6 6 0 0 1 5 3 l10 16 h-39 z" fill="#7DD3FC" opacity="0.9" />
          <rect x="204" y="56" width="14" height="8" rx="2" fill="#EAB308" />
          <rect x="150" y="66" width="34" height="8" rx="3" fill="#9CA3AF" />
          <Wheel cx={52} rotate={rotate} />
          <Wheel cx={88} rotate={rotate} />
          <Wheel cx={162} rotate={rotate} />
          <Wheel cx={198} rotate={rotate} />
        </svg>
      </div>
    </motion.div>
  );
};
